/* @flow */
import * as React from 'react'
import EmailSummary from './EmailSummary'
import EmailFullDefault from './EmailFull/Default'
import EmailFullVolny from './EmailFull/Volny'
import { isResponseFull } from './EmailUtils'
import { EmailConsumer } from '../../../context/Email'
import { type WidgetType } from './Types'

type InnerComponentProps = {|
  embedded: boolean,
  widget: WidgetType,
  container: Object,
  googleAnalytics?: any,
  EmailFullComponent: Object
|}

class Email extends React.PureComponent<InnerComponentProps> {
  render () {
    const {
      embedded = false,
      widget,
      googleAnalytics,
      EmailFullComponent
    } = this.props

    return (
      <EmailConsumer googleAnalytics={googleAnalytics}>
        { ({ handleLogoutClick, inbox, isLoading }) =>
          <div id={widget.name}>
            {isResponseFull(inbox) ? (
              <EmailFullComponent
                embedded={embedded}
                handleLogoutClick={handleLogoutClick}
                inbox={inbox}
                isLoading={isLoading}
                widget={widget}
              />
            ) : (
              <EmailSummary googleAnalytics={googleAnalytics} embedded={embedded} widget={widget} inbox={inbox} loading={isLoading}/>
            )}
          </div>
        }
      </EmailConsumer>
    )
  }
}

type ExportedComponentProps = {
  embedded: boolean,
  widget: WidgetType,
  container: Object
}

class DefaultEmail extends React.PureComponent<ExportedComponentProps> {
  render () {
    const {
      ...props
    } = this.props

    return (
      <Email {...props} EmailFullComponent={EmailFullDefault}/>
    )
  }
}

class VolnyEmail extends React.PureComponent<ExportedComponentProps> {
  render () {
    const {
      ...props
    } = this.props

    return (
      <Email {...props} EmailFullComponent={EmailFullVolny}/>
    )
  }
}

export { DefaultEmail, VolnyEmail }
